import Store from "@/store/"
import axios from "axios"

const SUPER_ADMIN = "superadmin"
const ADMIN = "admin"
const TEACHER = "teacher"
const STUDENT = "student"
const REFERENT = "referent"
const INTERN = "intern"

let rolesFetched = false
let cachedRoles = []

export const roles = [SUPER_ADMIN, ADMIN, TEACHER, STUDENT, REFERENT, INTERN]

export const updateRoles = async () => {
  if (!rolesFetched) {
    await axios.get("/api/v1/roles").then((response) => {
      cachedRoles = response.data.data.roles
      Store.dispatch("Auth/setRoles", cachedRoles)
      rolesFetched = true
    })
  }
  return cachedRoles
}

export const isAdmin = (roles) => {
  return roles.indexOf(SUPER_ADMIN) !== -1 || roles.indexOf(ADMIN) !== -1
}

export const isProfessor = (roles) => {
  return roles.indexOf(TEACHER) !== -1
}

export const refreshCSRFToken = async () => {
  try {
    const response = await axios.get('/csrf-token');
    document.querySelector('meta[name="csrf-token"]').setAttribute('content', response.data.token);
    return response.data.token;
  } catch (error) {
    console.error('Failed to refresh CSRF token', error);
    throw error;
  }
}

